export default __webpack_public_path__ + "static/media/omnes_medium-webfont.3f22b4b3.svg";